import React from "react";

const ListContext = React.createContext({});
ListContext.displayName = "ListContext";

export default ListContext;
